import { useState } from "react";
import { Play } from "lucide-react";

/** Click-to-play YouTube thumbnail card. */
export default function VideoCard({ item }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="relative group overflow-hidden border border-charcoal">
      <div className="relative aspect-video bg-charcoal">
        {playing ? (
          <iframe
            title={item.title}
            src={`https://www.youtube.com/embed/${item.youtubeVideoId}?autoplay=1`}
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            data-testid={`video-play-${item.id}`}
            className="absolute inset-0 w-full h-full text-left"
            aria-label={`Play ${item.title}`}
          >
            <img
              src={item.thumbnailUrl}
              alt={item.altText}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-transparent" />
            <div className="absolute inset-0 grid place-items-center">
              <span className="relative">
                <span className="absolute inset-0 rounded-full bg-emerald/40 animate-pulseRing" />
                <span className="relative grid place-items-center w-16 h-16 rounded-full bg-emerald text-ink">
                  <Play className="w-6 h-6 fill-current" />
                </span>
              </span>
            </div>
          </button>
        )}
      </div>
      <div className="p-4 md:p-5">
        <div className="text-eyebrow font-display font-bold uppercase tracking-[0.22em] text-emerald">
          {item.serviceCategory}
        </div>
        <h3 className="mt-2 text-white font-display font-semibold text-lg leading-tight">
          {item.title}
        </h3>
        {item.description && (
          <p className="mt-2 text-sm text-mutedtext">{item.description}</p>
        )}
      </div>
    </div>
  );
}
